import { Fab, SxProps } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';

export const fabStyle = {
  position: 'fixed',
  bottom: 16,
  right: 16,
};

export const fab = {
  color: 'primary' as 'primary',
  sx: fabStyle as SxProps,
  icon: <EditIcon />,
  label: 'Edit',
};

export const EditFab = (props: { setShow: (show: boolean) => void }) => {
  return (
    <Fab
      onClick={() => {
        props.setShow(true);
      }}
      sx={fab.sx}
      aria-label={fab.label}
      color={fab.color}
    >
      {fab.icon}
    </Fab>
  );
};
